const TiposColeta = [
    { cod: "01", descricao: "Material para Reparo c/ chamado de atendimento"},
    { cod: "02", descricao: "Material bom para estoque c/ chamado de atendimento"},
    { cod: "04", descricao: "Material reparo sem chamado de atendimento"},
    { cod: "05", descricao: "Material bom estoque sem chamado de atendimento"},
    { cod: "06", descricao: "Material para atendimento"},
    { cod: "08", descricao: "Acerto contábil OMRE03"},
    { cod: "10", descricao: "Material BBN (defeito)"},
    { cod: "12", descricao: "Acerto Contábil Fiscal"},
    { cod: "13", descricao: "Material BBN (bom)"},
    { cod: "14", descricao: "Acerto kit-vandalistmo - RF MÓVEL"},
  ];

  export default TiposColeta